<template lang="pug">
  v-layout(column)
    v-flex.box-histogram-formatter

</template>

<script>
import * as d3 from 'd3'
import { tip as d3Tip } from 'd3-v6-tip'

export default {
  props: [
    'datosHistogram',
    'widthBar',
    'widthHistogram',
    'heightHistogram',
    'right',
    'left',
    'bottom',
    'top'
  ],
  data () {
    return {
      datosAux: this.datosHistogram || [
        { 'anho': 2016, 'saldo': 5300 }
      ],
      dimensionesSvg: {
        width: this.widthHistogram || 300,
        bar: this.widthBar || 15,
        height: this.heightHistogram || 300,
        paddingRight: this.left || 35,
        paddingLeft: this.right || 30,
        paddingBottom: this.bottom || 20,
        paddingTop: this.top || 5
      }
    }
  },
  methods: {
    createHistogram () {
      let self = this

      let svg = d3.select('.box-histogram-formatter').append('svg')
        .attr('width', self.dimensionesSvg.width)
        .attr('height', self.dimensionesSvg.height)
        .style('background-color', '#ffffff')
        .append('g')
        .attr('transform', 'translate(' + self.dimensionesSvg.paddingRight + ',' + self.dimensionesSvg.paddingTop + ')')

      let tip = d3Tip()
        .attr('class', 'd3-tip')
        .offset([-9, 0])
        .html(function (event, d) {
          return '<span style=\'color:#0855C4;font-size:12px\'><b/>' + d + '</span>'
        })

      svg.call(tip)

      let xScale = d3.scaleLinear()
        .domain([d3.min(self.datosAux, function (d) { return d.anho }), d3.max(self.datosAux, function (d) { return d.anho })])
        .range([0, self.dimensionesSvg.width - self.dimensionesSvg.paddingRight - self.dimensionesSvg.paddingLeft])

      let yScale = d3.scaleLinear()
        .domain([d3.min(self.datosAux, function (d) { return d.saldo - 1000 }), d3.max(self.datosAux, function (d) { return d.saldo + 1000 })])
        .range([self.dimensionesSvg.height - self.dimensionesSvg.paddingBottom - self.dimensionesSvg.paddingTop, 0])

      let xAxis = d3.axisBottom(xScale)
        .ticks(self.datosAux.length)
        .tickFormat(function (d) { return d })

      let yAxis = d3.axisLeft(yScale)
        .ticks(6)
        .tickFormat(function (d) { return d })

      svg.append('g')
        .attr('transform', 'translate(' + self.dimensionesSvg.bar + ',' + (self.dimensionesSvg.height - self.dimensionesSvg.paddingBottom - self.dimensionesSvg.paddingTop) + ')')
        .call(xAxis)
        .classed('xAxis-formatter', 'true')

      svg.append('g')
        .call(yAxis)
        .classed('xAxis-formatter', 'true')

      let rect = svg.selectAll('rect').data(self.datosAux)
      rect.enter().append('rect')
        .attr('width', self.dimensionesSvg.bar)
        .attr('height', '0')
        .attr('y', (self.dimensionesSvg.height - self.dimensionesSvg.paddingBottom - self.dimensionesSvg.paddingTop))
        .attr('x', function (d) { return xScale(d.anho) + (self.dimensionesSvg.bar / 2) })
        .style('rx', (self.dimensionesSvg.bar / 2))
        .style('opacity', 0)
        .classed('box-rect-histogram-formatter', 'true')
        .transition().delay(function (d, i) { return i * 200 }).duration(1300)
        .style('opacity', 1)
        .style('fill',
          function (d) {
            return (d.saldo === d3.max(self.datosAux, function (d) { return d.saldo })) ? '#2DB398' : '#0855C4'
          })
        .attr('y', function (d) { return yScale(d.saldo) })
        .attr('height', function (d) { return ((self.dimensionesSvg.height - self.dimensionesSvg.paddingBottom - self.dimensionesSvg.paddingTop) - yScale(d.saldo)) })

      d3.selectAll('.box-rect-histogram-formatter')
        .on('mouseover', function (event, d) {
          tip.show(event, d.saldoFormatter)
        })
        .on('mouseout', tip.hide)
    }

  },
  mounted () {
    this.createHistogram()
  }

}
</script>

<style>
.xAxis-formatter>path,
line {
  stroke: #ffffff00;
}

.box-rect-histogram-formatter:hover {
  opacity: 0.9 !important;
  stroke-width: 1;
  stroke: #ffffff;
}

.d3-tip {
  font-family: Arial, Helvetica, sans-serif;
  line-height: 0px;
  padding: 10px;
  pointer-events: none !important;
  color: #203d5d;
  box-shadow: 0 0 4px 4px rgba(0, 20, 60, .1);
  background-color: #fff;
  border-radius: 4px;
  z-index: 99999999999;
}

/* Creates a small triangle extender for the tooltip */
.d3-tip:after {
  box-sizing: border-box;
  display: inline;
  font-size: 6px;
  width: 100%;
  line-height: 1;
  color: #fff;
  position: absolute;
  pointer-events: none;
}

/* Northward tooltips */
.d3-tip.n:after {
  content: "▼";
  margin: -1px 0 0 0;
  top: 100%;
  left: 0;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/HistogramaMain.vue